<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.index,
                    },
                    {
                        name: $tc('messages.group_practice_settings', 2),
                        href: null,
                    },
                    {
                        name: group.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="">
                    <div>
                        <AppWell class="mt-5 w-full" type="info">
                            <AppCard>
                                <div class="py-2">
                                    <div class="font-semibold">
                                        {{ $t('messages.advanced_options') }}
                                    </div>
                                    <div class="mt-3 flex flex-col gap-4">
                                        <div>
                                            <label class="flex gap-2 items-center">
                                                <input
                                                    type="checkbox"
                                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                    name="requires_previous_levels"
                                                    id="requires_previous_levels"
                                                    v-model="form.requires_previous_levels"
                                                />
                                                <span>{{ $t('messages.requires_previous_levels') }}</span>
                                            </label>
                                            <div class="pl-8 text-sm text-gray-600">
                                                <span>{{ $t('messages.requires_previous_levels_explanation') }}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <label class="flex gap-2 items-center">
                                                <input
                                                    type="checkbox"
                                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                    name="requires_correct_answer"
                                                    id="requires_correct_answer"
                                                    v-model="form.requires_correct_answer"
                                                />
                                                <span>{{ $t('messages.requires_correct_answer') }}</span>
                                            </label>
                                            <div class="pl-6 text-sm text-gray-600">
                                                <span>{{ $t('messages.requires_correct_answer_explanation') }}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <label class="flex gap-2 items-center">
                                                <input
                                                    type="checkbox"
                                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                    name="requires_level_reached"
                                                    id="requires_level_reached"
                                                    v-model="form.requires_level_reached"
                                                />
                                                <span>{{ $t('messages.requires_level_reached') }}</span>
                                            </label>
                                            <div class="pl-6 text-sm text-gray-600">
                                                <span>{{ $t('messages.requires_level_reached_explanation') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AppCard>
                        </AppWell>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import AppButton from '@/components/AppButton.vue';
import AppWell from '../../../../Shared/AppWell.vue';
import AppCard from '../../../../Shared/AppCard.vue';
import SmartBreadcrumbs from '../../../../components/SmartBreadcrumbs.vue';

export default {
    components: {
        SmartBreadcrumbs,
        AppCard,
        AppWell,
        PanelPage,
        TitleFieldsFormSection,
        AppButton,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'group', 'groupPracticeSetting'],
    data() {
        return {
            form: this.$inertia.form({
                requires_previous_levels: this.groupPracticeSetting.requires_previous_levels,
                requires_correct_answer: this.groupPracticeSetting.requires_correct_answer,
                requires_level_reached: this.groupPracticeSetting.requires_level_reached,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
